import { Link } from 'react-router-dom'
import { Shield, Home, ArrowLeft } from 'lucide-react'

const Unauthorized = () => {
  return (
    <div className="flex w-full min-w-0 flex-1 items-center justify-center">
      <title>Unauthorized | Talent Service</title>
      <div className="w-full min-w-0 max-w-lg space-y-8 text-center sm:space-y-10">

        {/* Illustration */}
        <div className="relative select-none">
          {/* Background glow */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="w-48 h-48 bg-red-500/10 dark:bg-red-400/5 rounded-full blur-3xl" />
          </div>

          {/* Large 403 number */}
          <div className="relative">
            <h1
              className="text-[7rem] font-black leading-none tracking-tighter text-light-bg-tertiary dark:text-dark-bg-tertiary sm:text-[10rem]"
              style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
            >
              403
            </h1>

            {/* Shield icon overlay */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-20 w-20 bg-gradient-to-br from-red-500 to-orange-500 dark:from-red-400 dark:to-orange-400 rounded-2xl rotate-12 flex items-center justify-center shadow-xl shadow-red-500/20">
                <Shield className="h-10 w-10 text-white -rotate-12" />
              </div>
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="space-y-3">
          <h2 className="text-2xl font-bold text-light-text-primary dark:text-dark-text-primary">
            Access Denied
          </h2>
          <p className="text-sm text-light-text-tertiary dark:text-dark-text-tertiary max-w-xs mx-auto leading-relaxed">
            You don't have permission to access this page. Contact the administrator to request access.
          </p>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-3 max-w-xs mx-auto">
          <Link
            to="/"
            className="flex-1 inline-flex items-center justify-center px-5 py-3 text-sm font-medium rounded-lg text-white bg-primary-600 hover:bg-primary-700 dark:bg-primary-650 dark:hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors shadow-md shadow-primary-600/20"
          >
            <Home className="h-4 w-4 mr-2" />
            Home
          </Link>

          <button
            onClick={() => window.history.back()}
            className="flex-1 inline-flex items-center justify-center px-5 py-3 border border-light-border-primary dark:border-dark-border-primary text-sm font-medium rounded-lg text-light-text-secondary dark:text-dark-text-secondary bg-light-bg-primary dark:bg-dark-bg-secondary hover:bg-light-bg-tertiary dark:hover:bg-dark-bg-tertiary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </button>
        </div>

        {/* Footer note */}
        <p className="text-xs text-light-text-tertiary/60 dark:text-dark-text-tertiary/60">
          Error 403 &middot; Forbidden
        </p>
      </div>
    </div>
  )
}

export default Unauthorized
